import { typography } from '../typography'
import colors from '../colors'

export const pagination = {
  hoverColor: colors.primary,
  fontFamily: typography.headings.fontFamily
}
export default pagination
